import Statistics from './Statistics.gql';

export default Statistics;
